export function getFlagIconNameByLocale(locale: string): string {
  const countryCode = locale.split('_')[1]?.toUpperCase();
  const flagIconPath = countryCode ? `flags/${countryCode}` : '';
  return flagIconPath;
}
